import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import ButtonWrapper from "../../../components/Button";
import InputWrapper from "../../../layout/inputWrapper";
import {
  ConstructionTypeOptions,
  natureOfConstructionOptions,
  planOnOptions,
  projectTypeOptions,
  specialProjectOptions,
  yesOrNo,
} from "../../../../TCPForms/data";
import FileUploader from "../../../reusableComponents/FileUploader2";
import { InfoBox } from "../../../components/StyledComponent";
import { Col, Container, Row } from "react-bootstrap";
import useDepartmentSelector from "../../../../TCPForms/hooks/useDepartmentSelector";
import { doc } from "prettier";

const SubStep1 = ({ formData, userInfo, handleTabChange, handleSubTabChange, setFormData, initFormMTDocs, isEmployee = false }) => {
  console.log(formData, "formDataFromSubStep1");
  const [, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  const { t } = useTranslation();
  const stateId = Digit.ULBService.getStateId();
  const designType = formData?.proposalType;
  const defaultValues = {
    ...formData,
    fastPASId: formData?.fastPASId,
    proposalType: formData?.proposalType,
    isSpecialProject: formData?.isSpecialProject,
    groundCoverages: formData?.groundCoverages,
    fars: formData?.fars,
    buildingHeight: formData?.buildingHeight,
    previousSetbackFront: formData?.setbackFronts,
    previousSetbackRear: formData?.setbackRears,
    natureOfConstructionOptions: formData?.natureOfConstructionOptions,
  };

  const { handleSubmit, control, setValue, watch, reset, getValues } = useForm({ defaultValues });
  const [fastPASData, setFastPasData] = useState(null);
  const [showToast, setShowToast] = useState(null);
  const { data, isLoading: isDropDataLoading } = Digit.Hooks.obps.useMDMS(stateId, "MapSubmission", "DropdownsConfig");
  const dropDownData = !isDropDataLoading && data?.MapSubmission?.DropdownsConfig?.[0];
  const schemeType = formData?.descriptionOfLand?.schemeType === "Scheme";

  const [
    watchProposalType,
    watchisSpecialProject,
    watchTypeOfProject,
    watchPlotSubdivided,
    watchNeedComp,
    watchplotLeaseHold,
    watchisRevised,
    watchNoOfPLots,
    watchisApprovedLayout,
    watchisSetbackRequired,
    watchPlanOn,
    watchSpecialGroundCoverage,
    watchisSpecialFAR,
    watchProjectType,
    watchnatureOfConstruction,
    watchbuildingClassification,
    watchlandUseType,
    watchSubZoneType,
    watchPrimaryUse,
    watchAtivityProposed,
    watchSectorNo,
    watchLandMark,
    watchKhasraNo,
  ] = watch([
    "proposalType",
    "isSpecialProject",
    "typeOfProject",
    "plotSubdivided",
    "needCompounding",
    "plotLeaseHold",
    "isRevised",
    "noOfPlots",
    "isApprovedLayout",
    "isSetbackRequired",
    "planOn",
    "isSpecialGroundCoverage",
    "isSpecialFAR",
    "projectType",
    "natureOfConstruction",
    "buildingClassification",
    "zoneType",
    "subZoneType",
    "primaryUse",
    "activityProposed",
    "sectorNo",
    "landMark",
    "khasraNo",
  ]);
  const mappedPlot = formData?.plotNumbers?.length;
  const totalPlots = parseInt(watchNoOfPLots, 10) || parseInt(mappedPlot, 10) || 0;
  const fullRows = Math.floor(totalPlots / 3);
  const remainingPlots = totalPlots % 3;

  const closeToast = () => {
    setShowToast(null);
  };
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);

  const convertDocuments = (docs) => {
    return docs.map((doc) => ({
      additionalDetails: {
        fileName: doc.docName,
        title: doc.docName,
      },
      auditDetails: null,
      documentRemarks: null,
      documentStatus: null,
      documentSubtype: null,
      documentType: doc.docName, // Or map from docName if needed
      documentUid: null,
      fileStoreId: doc.fileStoreId,
      id: doc.fileId,
      isNoc: "false",
      remarks: null,
    }));
  };
  const splitIfMultiple = (str) => {
    return str ? str.split(",").map((item) => item.trim()) : [];
  };
  const handleSearchClick = async (applicationNo) => {
    try {
      let response;
      let data;
      if (applicationNo) {
        response = await Digit.OBPSService.BPAmigratedSearchappNo({ applicationNo });
        console.log(response, "responseFromSearchhh");
        data = response?.Application;
        const docs = convertDocuments(data?.documents);
        const date = new Date(data?.architectDetail?.validityUpto);
        const isLayoutDevelopment = applicationNo?.split("/")[1] === "LD";
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        let owners = [];
        const names = splitIfMultiple(data?.ownerDetail?.ownerName);
        const contacts = splitIfMultiple(data?.ownerDetail?.ownerContactNo);
        const emails = splitIfMultiple(data?.ownerDetail?.ownerEmail);
        console.log(contacts, names, "contactsss");
        const isSameContact = contacts.every((contact) => contact === contacts[0]);
        if (isSameContact) {
          owners = [
            {
              name: names?.join(" & "),
              mobileNumber: contacts[0] || "", // Fallback if contacts/emails are missing
              emailId: emails[0] || "",
              permanentAddress: {
                state: data?.ownerDetail?.state,
                address: data?.ownerDetail?.addressLine1,
                type: "PERMANENT",
              },
              correspondenceAddress: {
                address: data?.ownerDetail?.siteAdress,
                pinNo: data?.ownerDetail?.pincode,
                type: "CORRESPONDENCE",
              },
            },
          ];
        } else {
          owners = names.map((name, index) => ({
            name: name,
            mobileNumber: contacts[index] || "", // Fallback if contacts/emails are missing
            emailId: emails[index] || "",
            permanentAddress: {
              state: data?.ownerDetail?.state,
              address: data?.ownerDetail?.addressLine1,
              type: "PERMANENT",
            },
            correspondenceAddress: {
              address: data?.ownerDetail?.siteAdress,
              pinNo: data?.ownerDetail?.pincode,
              type: "CORRESPONDENCE",
            },
          }));
        }
        console.log(owners, "ownerrrr");

        const formattedDate = `${day}/${month}/${year}`;
        const values = {
          prevSanctionNo: applicationNo,
          prevSanctionDate: data?.applicationDate,
          zoneType: data?.plotDetail?.landUseZone,
          subZoneType: data?.plotDetail?.landSubUseZone,
          primaryUse: data?.plotDetail?.plotUse,
          activityProposed: data?.plotDetail?.plotSubUse,
          communityParking: data?.plotDetail?.communityParking,
          natureOfConstruction: "Revalidation/Time Extension",
          department: applicationFlow,
          businessService: applicationFlow === "DA" ? "BPA_MAPSUB_DA" : "BPA_MAPSUB_AVP",
          isLayoutDevelopment: isLayoutDevelopment,
          tehsil: data?.projectDetail?.tehsil,
          projectType: data?.projectDetail?.projectType,
          district: data?.projectDetail?.district,
          revenueVillage: data?.projectDetail?.revenueVillage,
          landMark: data?.projectDetail?.landMark,
          plotArea: data?.plotDetail?.plotArea,
          totalBuildUpArea: data?.plotDetail?.totalBUA,
          totalExistingBuiltUpArea: data?.plotDetail?.existingBUA,
          maximumPermissibleGroundCoverage: data?.plotDetail?.groundCoverageArea,
          typeofArea: data?.plotDetail?.developmentArea,
          revenueVillageMohal: data?.projectDetail?.revenueVillage || null,
          plotAreaDoc: data?.plotDetail?.plotAreaAsDocument || null,
          plotAreaPos: null,
          siteAddress: data?.ownerDetail?.siteAddress,
          totalPlotArea: data?.plotDetail?.plotArea || 0,
          noOfBlocks: 0,
          selectedOffice: "Lucknow Development Authority",
          schemeName: data?.plotDetail?.scheme,
          buildingClassification: data?.projectDetail?.projectType,
          planOn: data?.plotDetail?.planOn,
          buildingHeight: data?.plotDetail?.maxBuildingHeight,
          isRevised: data?.projectDetail?.isRevised,
          isSpecialProject: data?.projectDetail?.specialProject,
          isApprovedLayout: data?.plotDetail?.approvedLayout,
          isSpecialGroundCoverage: data?.plotDetail?.groundCoverageArea,
          layoutsanctionNumber: data?.plotDetail?.layoutSanctionNo,
          layoutsanctionDate: data?.plotDetail?.layoutSanctionDate,
        };

        // Loop and set all values
        Object.entries(values).forEach(([key, value]) => {
          setValue(key, value);
        });
        await setFormData({
          ...formData,
          feeType: "ApplicationFee",

          workflow: { action: "INITIATE", assignes: null },
          tod: {
            orientDevelopment: null,
            convertedLandUseinTOD: null,
          },
          plotInfo: {
            ...formData?.plotInfo,
            estimatedCost: data?.plotDetail?.estimatedCost,
            builtupArea: data?.plotDetail?.totalBUA,
            plotArea: data?.plotDetail?.plotArea,
          },
          descriptionOfLand: {
            ...formData?.descriptionOfLand,
            landArea: data?.plotDetail?.plotArea,
          },
          professionaldetails: {
            ...formData?.professionaldetails,
            consultantCategory: data?.architectDetail?.consultantCategory,
            name: data?.architectDetail?.loginName,
            emailId: data?.architectDetail?.emailId,
            mobileNumber: data?.architectDetail?.mobileNumber,
            certificateNo: data?.architectDetail?.licenseNo,
            validupto: formattedDate,
          },
          landInfo: {
            ...formData?.landInfo,
            owners: owners,
            address: {
              city: null,
              locality: { code: "Lucknow" },
              region: null,
              doorNo: null,
              areaType: null,
            },
            tenantId: stateId,
          },
          documents: docs,
          sanctionFiles: data?.sanctionFiles,
        });
        initFormMTDocs(docs);
      }
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };

  const onSubmit = (data) => {
    handleSubTabChange(1, data);
  };
  if (applicationFlow === null) {
    return <DepartmentSelector />;
  }
  return (
    <section className="groupContainer2">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          {/* <div className="formHeaderContainer">
              <h4 className="formHeading" style={{ background: "#f2f2f2", textAlign: "end", fontSize: "20px", color: "green" }}>
                "High Risk"
              </h4>
            </div> */}
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Application Form")}</h2>
          </div>
          <Container fluid className="formInputContainer common-app-form">
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={t("Nature of Construction /Case Type")}
                  placeholder={t("Select Nature Of Construction")}
                  name="natureOfConstruction"
                  defaultValue={"Revalidation/Time Extension"}
                  data={natureOfConstructionOptions}
                  type="selectInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={isEmployee}
                />
              </Col>
              <Col>
                <InputWrapper
                  // style={{ marginTop: "-4px", paddingRight: "8px" }}
                  control={control}
                  label={t("Previous File No.")}
                  placeholder={t("Enter File No")}
                  name="mapSubDetails.prevFileNo"
                  defaultValue={formData?.prevsanctionNo}
                  type="textInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  showSearchIcon={true}
                  onSearchClick={() => handleSearchClick(getValues("prevSanctionNo"))}
                  disabled={isEmployee}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  // labelWidth={250}
                  label={t("Previous Sanction Date")}
                  placeholder={t("Select Prev Sanction Date")}
                  name="mapSubDetails.sanctionValidityStartDate"
                  defaultValue={formData?.prevSanctionDate}
                  type="datePicker"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={isEmployee}
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  label={t("Current Validity Date")}
                  placeholder={t("Select Date")}
                  name="mapSubDetails.sanctionValidityDate"
                  defaultValue={formData?.currValidityDate}
                  type="datePicker"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={isEmployee}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={t("Land Use")}
                  placeholder={t("Select Type of Land")}
                  name="zoneType"
                  defaultValue={formData?.zoneType}
                  type="selectInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={!!watchlandUseType}
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  label={t("Land Sub Use")}
                  placeholder={t("Select Type of Land Subuse")}
                  name="subZoneType"
                  defaultValue={formData?.subZoneType}
                  type="selectInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={watchSubZoneType}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={t("Primary Use of Proposed Activity")}
                  placeholder={t("Select Primary Use of Proposed Activity")}
                  name="primaryUse"
                  defaultValue={formData?.primaryUse}
                  type="selectInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={!!watchPrimaryUse}
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  label={t("Activity proposed")}
                  placeholder={t("Select Type of Activity proposed")}
                  name="activityProposed"
                  defaultValue={formData?.activityProposed}
                  type="selectInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={!!watchAtivityProposed}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                {" "}
                <InputWrapper
                  control={control}
                  data={planOnOptions}
                  label={t("Proposed Site")}
                  placeholder={t("Proposed Site")}
                  name="planOn"
                  defaultValue={formData?.planOn}
                  type="selectInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={isEmployee}
                />
              </Col>
              {watchPlanOn === "Others" ? (
                <Col>
                  {" "}
                  <InputWrapper
                    hasLabel={false}
                    control={control}
                    placeholder={t("Enter Proposed SIte")}
                    name="otherSchemeName"
                    mandatory
                    defaultValue={formData?.otherSchemeName}
                    type="textInput"
                    disabled={isEmployee}
                  />
                </Col>
              ) : (
                <Col></Col>
              )}
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  label={t("Layout Sanction No.")}
                  control={control}
                  placeholder={t("Enter layout sanction number")}
                  name="layoutsanctionNumber"
                  defaultValue={formData?.layoutsanctionNumber}
                  type="textInput"
                  disabled={isEmployee}
                />
              </Col>
              <Col>
                <InputWrapper
                  label={t("Layout Sanction Date")}
                  control={control}
                  placeholder={t("Enter Layout Sanction date")}
                  name="layoutsanctionDate"
                  defaultValue={formData?.layoutsanctionDate}
                  type="datePicker"
                  disabled={isEmployee}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  label={t("Is this Site falls in Metro City")}
                  control={control}
                  data={yesOrNo}
                  name="isMetroCity"
                  defaultValue={formData?.isMetroCity}
                  type="radioButton"
                  disabled={isEmployee}
                />
              </Col>
              {watchPlanOn === "Others" ? (
                <Col>
                  <InputWrapper
                    label={t("Development Area")}
                    control={control}
                    placeholder={t("Select Development Area Type")}
                    data={ConstructionTypeOptions}
                    name="descriptionOfLand.developmentArea"
                    mandatory
                    defaultValue={formData?.constructionType}
                    type="selectInput"
                    disabled={isEmployee}
                  />
                </Col>
              ) : (
                <Col></Col>
              )}
            </Row>
            {/* <Row>
              <Col></Col>
              {watchnatureOfConstruction && watchnatureOfConstruction !== "New" ? (
                <Col>
                  <InputWrapper
                    label={t("Prev File No")}
                    control={control}
                    placeholder={t("Enter File No")}
                    name="prevFileNo"
                    mandatory
                    maxLength={19}
                    defaultValue={formData?.prevFileNo}
                    type="textInput"
                    disabled={isEmployee}
                  />
                </Col>
              ) : (
                <Col></Col>
              )}
            </Row> */}
            <Row>
              <Col>
                {schemeType && (
                  <InputWrapper
                    label="Scheme Name"
                    control={control}
                    placeholder="Select Scheme Name"
                    defaultValue={formData?.schemeName}
                    name={`schemeName`}
                    type="selectInput"
                    mandatory
                    data={dropDownData?.schemeName}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    disabled={fastPASData?.descriptionOfLand?.schemeName || isEmployee}
                  />
                )}
              </Col>
              {/* <InputWrapper
                                control={control}
                                data={updistricts}
                                label={t("District")}
                                placeholder={t("Select District")}
                                defaultValue={formData?.district}
                                name={`district`}
                                type="selectInput"
                                mandatory
                                validation={{
                                    required: {
                                        value: true,
                                        message: "This field is required"
                                    }
                                }}
                            /> */}
              <Col>
                {" "}
                <InputWrapper
                  label={t("Tehsil")}
                  control={control}
                  placeholder={t("Enter Tehsil")}
                  name="tehsil"
                  defaultValue={formData?.tehsil}
                  type="textInput"
                  disabled={isEmployee}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  label="Revenue Village/Colony Name"
                  control={control}
                  placeholder="Enter Revenue Village"
                  defaultValue={formData?.revenueVillage}
                  name={`revenueVillage`}
                  type="textInput"
                  disabled={isEmployee}
                />
              </Col>
              <Col>
                <InputWrapper
                  label={t("Land Mark")}
                  control={control}
                  placeholder={t("Enter Land Mark")}
                  name="landMark"
                  mandatory
                  maxLength={15}
                  defaultValue={formData?.landMark}
                  type="textInput"
                  disabled={watchLandMark || isEmployee}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                {schemeType && (
                  <InputWrapper
                    label={t("Sector/Pocket No.")}
                    control={control}
                    placeholder={t("Enter Sector/Pocket No.")}
                    name="sectorNo"
                    mandatory
                    maxLength={15}
                    defaultValue={formData?.sectorNo}
                    type="textInput"
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    disabled={isEmployee}
                  />
                )}
              </Col>
              <Col>
                <InputWrapper
                  label={schemeType ? t("Plot No") : t("Plot No./Khasra No./ Arazi No.")}
                  control={control}
                  placeholder={schemeType ? t("Enter Plot no") : t("Enter Plot No./Khasra No./ Arazi No.")}
                  name={schemeType ? "plotNo" : "descriptionOfLand.khasraDetails.[0].plotNo"}
                  mandatory
                  defaultValue={formData?.plotNo || formData?.descriptionOfLand?.plotNo || fastPASData?.descriptionOfLand?.plotNo}
                  type="textInput"
                  disabled={fastPASData?.descriptionOfLand?.plotNo || formData?.plotNo}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={`${t("Standard Type Design")}`}
                  name="proposalType"
                  defaultValue={formData?.proposalType || designType}
                  type="radioButton"
                  mandatory
                  data={yesOrNo}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={isEmployee}
                />
              </Col>
              <Col></Col>
              {/* {schemeType && (
                <Col>
                  <InputWrapper
                    label={t("Plot No")}
                    control={control}
                    placeholder={t("Enter Plot no")}
                    name="plotNo"
                    mandatory
                    defaultValue={formData?.plotNo || fastPASData?.descriptionOfLand?.plotNo}
                    type="textInput"
                    disabled={fastPASData?.descriptionOfLand?.plotNo || formData?.plotNo || isEmployee}
                  />
                </Col>
              )} */}
            </Row>
            <Row>
              {watchProposalType === "yes" && (
                <Col>
                  <InputWrapper
                    label={t("Sanction date of layout")}
                    control={control}
                    placeholder={t("Enter Sanction date Of layout")}
                    name="sanctionDate"
                    mandatory
                    defaultValue={formData?.sanctionDate}
                    type="datePicker"
                    disabled={isEmployee}
                  />
                </Col>
              )}
              {watchProposalType === "yes" && (
                <Col>
                  <InputWrapper
                    label={t("Sanction number of layout")}
                    control={control}
                    placeholder={t("Enter Sanction number Of layout")}
                    name="sanctionNumber"
                    mandatory
                    defaultValue={formData?.sanctionNumber}
                    type="textInput"
                    disabled={isEmployee}
                  />
                </Col>
              )}
            </Row>
            {/* No Of Plots mapping  */}
            {watchProposalType === "yes" && (
              <Row>
                <Col>
                  {" "}
                  <InputWrapper
                    label={t("No. Of Plots")}
                    control={control}
                    placeholder={t("Enter No. Of PLots")}
                    name="noOfPlots"
                    mandatory
                    defaultValue={formData?.noOfPlots}
                    type="textInput"
                    disabled={isEmployee}
                  />
                </Col>
                <Col></Col>
              </Row>
            )}

            {watchProposalType === "yes" && (
              <React.Fragment>
                {/* Full rows */}
                {Array.from({ length: fullRows }).map((_, rowIndex) => (
                  <Row key={rowIndex}>
                    {Array.from({ length: 3 }).map((_, colIndex) => {
                      const plotIndex = rowIndex * 3 + colIndex;
                      return (
                        <Col key={`plot-${plotIndex}`}>
                          <InputWrapper
                            control={control}
                            placeholder={t("Enter Plot No")}
                            name={`plotNumbers.${plotIndex}`} // Use dot notation
                            mandatory
                            hasLabel={false}
                            maxLength={15}
                            defaultValue={formData?.plotNumbers?.[plotIndex] || ""}
                            type="textInput"
                            disabled={isEmployee}
                          />
                        </Col>
                      );
                    })}
                  </Row>
                ))}

                {/* Remaining plots */}
                {remainingPlots > 0 && (
                  <Row key={fullRows}>
                    {Array.from({ length: remainingPlots }).map((_, colIndex) => {
                      const plotIndex = fullRows * 3 + colIndex;
                      return (
                        <Col key={`plot-${plotIndex}`}>
                          <InputWrapper
                            control={control}
                            placeholder={t("Enter Plot No")}
                            name={`plotNumbers.${plotIndex}`} // Use dot notation
                            mandatory
                            maxLength={15}
                            hasLabel={false}
                            defaultValue={formData?.plotNumbers?.[plotIndex] || ""}
                            type="textInput"
                            disabled={isEmployee}
                          />
                        </Col>
                      );
                    })}
                  </Row>
                )}
              </React.Fragment>
            )}
            {/* 
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  data={watchPlanOn === "Others" ? projectTypeOptions.filter((e) => e.name !== "Building Permission-Low Risk") : projectTypeOptions}
                  label={`${t("Project Type")}`}
                  placeholder={"Select Project Type"}
                  name="buildingClassification"
                  defaultValue={formData?.buildingClassification}
                  type={watchPlanOn ? "textInput" : "selectInput"}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={!!watchPlanOn || isEmployee}
                />
              </Col>
              <Col>
                {watchbuildingClassification === "Others" && (
                  <Col>
                    <InputWrapper
                      label={t("Other Project")}
                      control={control}
                      placeholder={t("Enter  Name")}
                      name="otherbuildingClass"
                      mandatory
                      defaultValue={formData?.otherbuildingClass}
                      type="textInput"
                      disabled={isEmployee}
                    />
                  </Col>
                )}
              </Col>
            </Row> */}

            {/* {watchnatureOfConstruction !== 'New' && <Row>
                            <Col><InputWrapper
                                control={control}
                                data={dropDownData?.yesOrNo}
                                label={t("Is Revised")}
                                placeholder={t("Is Revised")}
                                name="isRevised"
                                defaultValue={formData?.isRevised}
                                type="radioButton"
                                mandatory
                                validation={{
                                    required: {
                                        value: true,
                                        message: "This field is required"
                                    }
                                }}
                            />
                            </Col>
                            {watchisRevised === 'yes' && <Col>
                                <InputWrapper
                                    label={t("Prev File No")}
                                    control={control}
                                    placeholder={t("Enter File No")}
                                    name="prevFileNo"
                                    mandatory
                                    maxLength={15}
                                    defaultValue={formData?.prevFileNo}
                                    type="textInput"
                                /></Col>
                            }
                        </Row>} */}
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={`${t("Special Project type")}`}
                  name="isSpecialProject"
                  defaultValue={formData?.isSpecialProject}
                  type="radioButton"
                  data={yesOrNo}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={isEmployee}
                />
              </Col>
              <Col>
                {" "}
                {(watchlandUseType !== "Residential" || watchPrimaryUse !== "Residential") && (
                  <InputWrapper
                    control={control}
                    data={yesOrNo}
                    label={t("If Community Parking Provided")}
                    placeholder={t("Select Community Parking")}
                    name="communityParking"
                    defaultValue={formData?.communityParking}
                    type="selectInput"
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    disabled={isEmployee}
                  />
                )}
              </Col>
            </Row>
            {watchisSpecialProject === "yes" && (
              <Row>
                <Col>
                  <InputWrapper
                    label={t("Special Condition of Project")}
                    control={control}
                    placeholder={t("Select Condition of Project")}
                    data={specialProjectOptions}
                    name="projectType"
                    mandatory
                    defaultValue={formData?.projectType}
                    type="selectInput"
                    disabled={isEmployee}
                  />
                </Col>
                <Col>
                  {watchProjectType === "Other" && (
                    <Col>
                      <InputWrapper
                        label={t("Other Project")}
                        control={control}
                        placeholder={t("Enter  Name")}
                        name="otherProjectName"
                        mandatory
                        defaultValue={formData?.otherProjectName}
                        type="textInput"
                        disabled={isEmployee}
                      />
                    </Col>
                  )}
                </Col>
              </Row>
            )}

            {(watchProjectType === "Building Design as per standard Drawing" ||
              watchProjectType === "Standard condition as per Lease deed/freehold deed") &&
              watchisSpecialProject === "yes" && (
                <Row>
                  <Col>
                    {" "}
                    <InputWrapper
                      control={control}
                      label={t("Ground Coverage")}
                      placeholder={t("Enter Ground Coverage")}
                      name="groundCoverages"
                      defaultValue={formData?.groundCoverages || formData?.groundCoverage}
                      type="textInput"
                      mandatory
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                      maxLength={4}
                      disabled={isEmployee}
                    />
                  </Col>

                  <Col>
                    {" "}
                    <InputWrapper
                      control={control}
                      label={t("FAR")}
                      placeholder={t("Enter FAR")}
                      name="fars"
                      defaultValue={formData?.fars || formData?.far}
                      type="textInput"
                      mandatory
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                      maxLength={4}
                      disabled={isEmployee}
                    />
                  </Col>
                </Row>
              )}

            {(watchProjectType === "Building Design as per standard Drawing" ||
              watchProjectType === "Standard condition as per Lease deed/freehold deed") &&
              watchisSpecialProject === "yes" && (
                <Row>
                  <Col>
                    {" "}
                    <InputWrapper
                      control={control}
                      label={t("Building Height")}
                      placeholder={t("Enter Building Height")}
                      name="buildingHeight"
                      defaultValue={formData?.buildingHeight}
                      type="textInput"
                      mandatory
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                      maxLength={4}
                      disabled={isEmployee}
                    />
                  </Col>
                  <Col>
                    <InputWrapper
                      control={control}
                      label={t("Please specify if any other condition")}
                      placeholder={t("Enter condition")}
                      name="anyotherCondition"
                      defaultValue={formData?.anyotherCondition}
                      type="textInput"
                      mandatory
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                      disabled={isEmployee}
                    />
                  </Col>
                </Row>
              )}

            {(watchProjectType === "Building Design as per standard Drawing" ||
              watchProjectType === "Standard condition as per Lease deed/freehold deed") &&
              watchisSpecialProject === "yes" && (
                <Row>
                  <Col>
                    <InputWrapper
                      label={t("Front")}
                      control={control}
                      placeholder={t("Enter Setback Front")}
                      name="previousSetbackFront"
                      mandatory
                      maxLength={2}
                      defaultValue={formData?.previousSetbackFront || formData?.setbackFronts}
                      type="textInput"
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                      disabled={isEmployee}
                    />
                  </Col>
                  <Col>
                    {" "}
                    <InputWrapper
                      label={t("Rear")}
                      control={control}
                      placeholder={t("Enter Setback Rear")}
                      name="previousSetbackRear"
                      mandatory
                      maxLength={2}
                      defaultValue={formData?.previousSetbackRear || formData?.setbackRears}
                      type="textInput"
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                      disabled={isEmployee}
                    />
                  </Col>
                </Row>
              )}

            {(watchProjectType === "Building Design as per standard Drawing" ||
              watchProjectType === "Standard condition as per Lease deed/freehold deed") &&
              watchisSpecialProject === "yes" && (
                <Row>
                  <Col>
                    <InputWrapper
                      label={t("Side Setback-1")}
                      control={control}
                      placeholder={t("Enter Setback Left")}
                      name="previousSetbackSide1"
                      mandatory
                      maxLength={2}
                      defaultValue={formData?.previousSetbackSide1 || formData?.setbackSide1}
                      type="textInput"
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                      disabled={isEmployee}
                    />
                  </Col>
                  <Col>
                    {" "}
                    <InputWrapper
                      label={t("Side Setback-2")}
                      control={control}
                      placeholder={t("Enter Setback Right")}
                      name="previousSetbackSide2"
                      mandatory
                      maxLength={2}
                      defaultValue={formData?.previousSetbackSide2 || formData?.setbackSide2}
                      type="textInput"
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                      disabled={isEmployee}
                    />
                  </Col>
                </Row>
              )}
            {fastPASData && fastPASData?.descriptionOfLand?.landArea < 40000 && (
              <Row>
                <Col>
                  <InputWrapper
                    control={control}
                    data={yesOrNo}
                    label={`${t("Will You Pay Shelter Fee")}`}
                    name="shelterFee"
                    defaultValue={formData?.shelterFee}
                    type="radioButton"
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    disabled={isEmployee}
                  />
                </Col>
                <Col></Col>
              </Row>
            )}
            {/* Additional Detail */}

            <Row>
              {(watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" ||
                watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm") && (
                <Col>
                  <InputWrapper
                    label={t("Is Your Plot sub-division")}
                    control={control}
                    name="plotSubdivided"
                    mandatory
                    data={yesOrNo}
                    defaultValue={formData?.plotSubdivided}
                    type="radioButton"
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    disabled={isEmployee}
                  />
                </Col>
              )}
            </Row>
            <Row>
              {watchPlotSubdivided === "no" && (
                <Col>
                  <InputWrapper
                    label={t("Does existing building require any compounding ?")}
                    control={control}
                    name="needCompounding"
                    mandatory
                    data={yesOrNo}
                    defaultValue={formData?.needCompounding}
                    type="radioButton"
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    disabled={isEmployee}
                  />
                </Col>
              )}
            </Row>

            <Row>
              {watchNeedComp === "no" && watchPlotSubdivided === "no" && (
                <Col>
                  <InputWrapper
                    label={t("Is your plot Lease hold ?")}
                    control={control}
                    name="plotLeaseHold"
                    mandatory
                    data={yesOrNo}
                    defaultValue={formData?.plotLeaseHold}
                    type="radioButton"
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    disabled={isEmployee}
                  />
                </Col>
              )}
              {watchplotLeaseHold === "yes" && (
                <Col>
                  <FileUploader
                    label={"Noc For Lease Hold"}
                    control={control}
                    name="leaseholdNOC"
                    validationMsg="(jpg, jpeg, png file only and Max file Size 10 MB)"
                    required
                    isMandatory
                    tab={1}
                  />
                </Col>
              )}
            </Row>
            {watchPlotSubdivided === "yes" || watchplotLeaseHold === "yes" ? (
              <InfoBox>
                Not authorized for Self Certification Approval of Map <span>*</span>
              </InfoBox>
            ) : (
              watchNeedComp === "yes" && (
                <InfoBox>
                  Kindly apply on Compounding Module <span>*</span>
                </InfoBox>
              )
            )}
          </Container>
        </div>

        {!isEmployee && (
          <div className="footerContainer">
            <div className="buttonWrapper">
              <ButtonWrapper variant="contained" color="success" size="medium" label="Save" type="submit" sx={{ backgroundColor: "#157CB3" }} />
            </div>
          </div>
        )}
      </form>
    </section>
  );
};

export default SubStep1;
